import { createAction } from '@wix/communities-blog-client-common';

export const SET_IS_SAVING = 'isSaving/SET';

export const setIsSaving = createAction(SET_IS_SAVING);
